
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";
import { User } from "../../interface/user";
import * as moment from 'moment'

@Injectable()
export class UserService {
  userExportPer;
  private userAction = new Subject();
  constructor(private router: Router, private httpClient: HttpClient) {
  }

  isAuthenticated(): boolean {
    let user: User = this.getLoggedInUser();
    if (user.ownerId) {
      // logged in so return true
      return true;
    }

    return false;
  }

  getLoggedInUser(): any {
    let user = {
      ownerId: ""
    };
    if (localStorage.getItem("sdsxc")) {
      user = JSON.parse(atob(localStorage.getItem("sdsxc")));
    }
    return user;
  }

  savePersonalDetailsToToken(data: any): void {
    let user: any = this.getLoggedInUser();
    if (data.name) {
      user.name = data.name;
    }
    if (data.mobile) {
      user.mobile = data.mobile;
    }
    if (data.address) {
      user.address = data.address;
    }
    if (data.profileImage) {
      user.profileImage = data.profileImage;
    }
    if (data.defaultDashboard || data.defaultDashboard == "") {
      user.defaultDashboard = data.defaultDashboard;
    }
    if (data.defaultDashboardName || data.defaultDashboardName == "") {
      user.defaultDashboardName = data.defaultDashboardName;
    }
    localStorage.setItem("sdsxc", btoa(JSON.stringify(user)));
    setTimeout(() => {
      this.userDetailsSendUpdateEvent();
    }, 500);
  }

  getToken(): string {
    let token: string = this.getLoggedInUser().token;
    return token;
  }

  getOwnerId(): string {
    let ownerId: string = this.getLoggedInUser().ownerId;
    return ownerId;
  }

  login(userName, password,otp): Observable<User> {
    let body = {
      credential: {
        email: userName,
        password: password,
        otp : otp
      }
    };

    return this.httpClient.post<User>("customer/login", body).map(res => {
      //sds xpandretail customer
      if (!res["settings"]["thousandSymbol"])
        res["settings"]["thousandSymbol"] = ",";
      if (!res["settings"]["decimalSymbol"])
        res["settings"]["decimalSymbol"] = ".";
      localStorage.setItem("sdsxc", btoa(JSON.stringify(res)));
      this.settingOperation();
      return res;
    });
  }

  checkMFAAuth(userName, password): Observable<any> {
    let body = {
      credential: {
        email: userName,
        password: password
      }
    };

    return this.httpClient.post<any>("customer/mfa", body);
  }

  settingOperation() {
    let userP = this.getLoggedInUser();
    this.userExportPer = userP.settings;
    this.getOffsetValueFromSetting(true);
    this.getOffsetValueFromSetting(false);

  }


  getOffsetValueFromSetting(isAdd) {
    let isOffsetPresent = localStorage.getItem('settingOffset' + (isAdd ? "Add" : "Remove"));
    let offsetV;
    if (!isOffsetPresent) {
      let browersLocalffset = "";
      let offsetSetting = "";
      let settingOffset = Object.assign({}, this.userExportPer);
      settingOffset = settingOffset.localOffSet.replace(':', '.');
      console.log("settingOffset ", settingOffset);

      let tz = new Date().getTimezoneOffset();
      let tzh = Math.abs(Math.round(tz / 60));
      let tzm = Math.abs(tz % 60);
      if (tz > 0) {
        browersLocalffset = "+" + tzh + "." + tzm;
      } else {
        browersLocalffset = "-" + tzh + "." + tzm;
      }

      if (isAdd) {
        offsetSetting = (parseFloat(settingOffset) - parseFloat(browersLocalffset)).toFixed(2).toString();
      } else {
        offsetSetting = (parseFloat(settingOffset) + parseFloat(browersLocalffset)).toFixed(2).toString();
      }

      let splitV = offsetSetting.split('.');
      let firstV = splitV[0];
      let lastV = splitV[1];
      //if it's start with negative
      if (firstV.charAt(0) == "-") {
        firstV = "-" + this.addZero(firstV.replace("-", ""));
      }
      else {
        firstV = this.addZero(firstV);
      }

      if (firstV.length == 2) {
        firstV = "+" + firstV;
      }

      if (!isAdd) {
        firstV = (firstV.charAt(0) != "-" ? "-" : "+") + firstV.replace("-", "").replace("+", "");
      }

      offsetV = `${firstV}:${lastV}`;
      localStorage.setItem('settingOffset' + (isAdd ? "Add" : "Remove"), offsetV);
    }
    else {
      offsetV = isOffsetPresent;
    }
    return offsetV;
  }

  addZero(date) {
    return (date < 10) ? "0" + date : date;
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(["/login"]);
  }

  changePasswordService(oldPassword, newPassword): Observable<any> {
    return this.httpClient.post("customer/changePassword", {
      oldPassword: oldPassword,
      newPassword: newPassword
    });
  }

  userDetailsUpdated(): Observable<any> {
    return this.userAction.asObservable();
  }

  userDetailsSendUpdateEvent() {
    this.userAction.next();
  }

  forgotPassword(form): Observable<any> {
    return this.httpClient.post("customer/forgotPassword", form);
  }

  resetPassword(form): Observable<any> {
    return this.httpClient.post("customer/changePasswordByResetToken", form);
  }

  changeProfilePhoto(form): Observable<any> {
    var headers = new HttpHeaders();
    headers.delete('Content-Type');

    return this.httpClient.post("customer/updateImage", form, { headers: headers });
  }

  redirectToHome(router) {
    let user = this.getLoggedInUser();
    if (user.defaultDashboard == "") {
      router.navigate(["/dashboard"]);
    } else {
      router.navigate(["/private-dashboard/" + user.defaultDashboardName + "/" + user.defaultDashboard]);
    }
  }

  getOffsetconvertUtc(dateTime, dateFormat = "YYYY-MM-DDTHH:mm:ss.SSS") {
    if (!this.userExportPer) {
      this.settingOperation();
    }
    return moment.utc(dateTime).utcOffset(this.userExportPer.localOffSet).format(dateFormat);
  }

  async requestRetrain() {
    // return this.httpClient.post("customer/retrainData",[]);
    const promise = this.httpClient.post("customer/retrainData", []).toPromise();
    promise.then((data) => {
      return "success";
    }).catch((error) => {
      return "error";
    });
  }

  updateSymbol(form): Observable<any> {
    let body = form;
    return this.httpClient.patch("customer/updateSymbol", body);
  };

  setSymbolSetting(data: any): void {
    let user: any = this.getLoggedInUser();
    if (data.thousandSymbol)
      user.settings.thousandSymbol = data.thousandSymbol;
    if (data.decimalSymbol)
      user.settings.decimalSymbol = data.decimalSymbol;

    localStorage.setItem("sdsxc", btoa(JSON.stringify(user)));
    setTimeout(() => {
      this.userDetailsSendUpdateEvent();
    }, 500);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/user/user.service.ts